/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Base picker store to define base functions related to data retrieval for a picker.
 */
'use strict';

angular.module('stores.picker', []).factory('PickerStore', function ($filter) {
  /**
   * Function to be returned.  It is a base picker store to be extended. It is expected
   * that any extending stores will work with a server that is driving the controller that
   * is making use of the store.
   * @constructor
   */
  var PickerStore = function () {
    this.nextTooltipText = $filter('i18n')('NEXT');
    this.previousTooltipText = $filter('i18n')('PREVIOUS');
    this.latestLabel = $filter('i18n')('LATEST');
  };

  PickerStore.prototype.name = 'PickerStore';

  /**
   * Get the string to be used for the next tooltip.
   *
   * @returns {String} - The tooltip string or empty string for no tooltip.
   */
  PickerStore.prototype.getNextTooltip = function () {
    return this.nextDisabled() ? '' : this.nextTooltipText;
  };

  /**
   * Get the string to be used for the previous tooltip.
   *
   * @returns {String} - The tooltip string or empty string for no tooltip.
   */
  PickerStore.prototype.getPreviousTooltip = function () {
    return this.previousDisabled() ? '' : this.previousTooltipText;
  };

  // Define functions to be implemented by extending service.
  /**
   * Load the next object in the picker.
   */
  PickerStore.prototype.getNext = function () {
    throw new Error('getNext must be implemented in extending service');
  };

  /**
   * Load the previous object in the picker.
   */
  PickerStore.prototype.getPrevious = function () {
    throw new Error('getPrevious must be implemented in extending service');
  };

  /**
   * Get the most recent object in the picker.
   */
  PickerStore.prototype.getLatest = function () {
    throw new Error('getLatest must be implemented in extending service');
  };

  /**
   * Get the object by date.
   * @params {Date} dateOfInterest - the date to use for lookup.
   */
  PickerStore.prototype.getByDate = function () {
    throw new Error('getByDate must be implemented in extending service');
  };

  /**
   * Get the id of the object that was backed up earliest.
   *
   * @returns {Number} - The id.
   */
  PickerStore.prototype.getMin = function () {
    throw new Error('getMin must be implemented in extending service');
  };

  /**
   * Get the id of the object most recently backed up.
   *
   * @returns {Number} - The id.
   */
  PickerStore.prototype.getMax = function () {
    throw new Error('getMax must be implemented in extending service');
  };

  /**
   * Should the previous button be disabled.
   *
   * @return {Boolean} - true if the button should be disabled.
   */
  PickerStore.prototype.previousDisabled = function () {
    throw new Error('previousDisabled must be implemented in extending service');
  };

  /**
   * Should the next button be disabled.
   *
   * @returns {Boolean} - true if the button should be disabled.
   */
  PickerStore.prototype.nextDisabled = function () {
    throw new Error('nextDisabled must be implemented in extending service');
  };

  /**
   * Function used to setup of watch for the value of interest if need be.
   * @param {Object} $scope - The scope to attach the watch.  Note the handler of the
   * watch should update scope values.
   */
  PickerStore.prototype.setupDateTimeListener = function () {
    throw new Error('setupDateTimeListener must be implemented in extending service');
  };

  return PickerStore;
});
